import type { FishPriceWon, FishProductId, FishRoundResult } from "../types";

export interface PriceResolutionInput {
  readonly productId: FishProductId;
  readonly sellerPrices: readonly {
    readonly playerId: string;
    readonly priceWon: FishPriceWon;
  }[];
  readonly revenueUnitCount: number;
  readonly hidden: boolean;
}

export function resolveProductPricing(
  input: PriceResolutionInput,
): FishRoundResult | null {
  if (input.sellerPrices.length === 0 || input.revenueUnitCount <= 0) {
    return null;
  }

  const finalPriceWon = input.sellerPrices.reduce<FishPriceWon>(
    (lowest, sellerPrice) =>
      sellerPrice.priceWon < lowest ? sellerPrice.priceWon : lowest,
    input.sellerPrices[0].priceWon,
  );
  const winnerIds = input.sellerPrices
    .filter((sellerPrice) => sellerPrice.priceWon === finalPriceWon)
    .map((sellerPrice) => sellerPrice.playerId);
  const totalRevenueWon = finalPriceWon * input.revenueUnitCount;
  const payoutWon = Math.floor(totalRevenueWon / winnerIds.length);
  const payoutByPlayerId = Object.fromEntries(
    winnerIds.map((winnerId) => [winnerId, payoutWon]),
  );

  return {
    productId: input.productId,
    soldTicketCount: input.revenueUnitCount,
    finalPriceWon,
    totalRevenueWon,
    winnerIds,
    payoutByPlayerId,
    hidden: input.hidden,
  };
}
